let nextNotificationId = 1;
const timers = new Map();

export const notificationState = $state({
  items: [],
});

export function notify(options) {
  const item = typeof options === 'string'
    ? { title: 'AquaOS', message: options }
    : options;
  const id = nextNotificationId++;
  notificationState.items.unshift({
    id,
    title: item.title ?? 'AquaOS',
    message: item.message ?? '',
    icon: item.icon ?? 'software-update',
    actionLabel: item.actionLabel ?? null,
    action: item.action ?? null,
  });
  while (notificationState.items.length > 4) {
    dismissNotification(notificationState.items.at(-1)?.id);
  }
  timers.set(id, setTimeout(() => dismissNotification(id), item.timeout ?? 5000));
  return id;
}

export function dismissNotification(id) {
  const index = notificationState.items.findIndex((item) => item.id === id);
  if (index !== -1) notificationState.items.splice(index, 1);
  clearTimeout(timers.get(id));
  timers.delete(id);
}

export function runNotificationAction(item) {
  item.action?.();
  dismissNotification(item.id);
}
